module.exports = __webpack_public_path__ + "static/media/lock-icon.6d7431eb.svg";